import {useContext} from 'react';
import ObserverContext, {
  ObserverContextProps,
} from '@/contexts/observerContext';

const useObserverContext = (): ObserverContextProps => {
  const context = useContext(ObserverContext);

  if (!context) {
    throw new Error(
      'useObserverContext must be used within an ObserverContextProvider',
    );
  }

  return context;
};

export default useObserverContext;
